export const initialState = {
    showsList: null,
    activeShows:null
  };